import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { userConsentBackend } from './user-consent.backend';
import { userConsentReducer } from './user-consent.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('userConsent', userConsentReducer),
    BackendModule.forFeature('userConsent', userConsentBackend),
  ],
})
export class DatastoreUserConsentModule {}
